import DesLibraryPropertiesViewModel from 'viewmodel/DesLibraryPropertiesViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';

export default class DesLibraryProperties extends DesBaseCatalogAcc {
    constructor() {
        super(DesLibraryPropertiesViewModel);
    }

    get locale() {
        return this.getAttribute('locale') || 'en_US';
    }

    get libraryId() {
        return this.getAttribute('libraryid') || this.getAttribute('library-id');
    }

    getProps() {
        return {
            libraryid: this.libraryId
        };
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'locale', 'libraryid', 'library-id'];
    }
}

if (!window.customElements.get('des-library-properties')) {
    window.customElements.define('des-library-properties', DesLibraryProperties);
}
